export default __webpack_public_path__ + "static/media/logo.e3321b3a.svg";